module.exports = __webpack_public_path__ + "img/21.031c88c6.png";